(function () {
  const section = document.querySelector('[data-gallery]');
  if (!section) return;

  const enableZoom = section.dataset.enableZoom === 'true';
  const enableLightbox = section.dataset.enableLightbox === 'true';
  const enableSwipe = section.dataset.enableSwipe === 'true';

  const slides = [...section.querySelectorAll('[data-gallery-slide]')];
  if (!slides.length) return;

  const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
  const main = section.querySelector('[data-gallery-main]');
  const counter = section.querySelector('[data-gallery-counter]');
  const prevBtn = section.querySelector('[data-gallery-prev]');
  const nextBtn = section.querySelector('[data-gallery-next]');
  const expandBtn = section.querySelector('[data-gallery-expand]');
  const lightbox = document.querySelector('[data-lightbox]');
  const hasModels = slides.some((s) => s.dataset.mediaType === 'model');

  function track(name, data) {
    if (window.BcosAnalytics && typeof window.BcosAnalytics.track === 'function') {
      window.BcosAnalytics.track(name, data || {}, 'analytics');
    }
  }

  function currentIndex() {
    return slides.findIndex((s) => s.classList.contains('bcos-gallery__slide--active'));
  }

  function setActive(index, options = {}) {
    const count = slides.length;
    let next = index;
    if (next < 0) next = count - 1;
    if (next >= count) next = 0;

    slides.forEach((s, i) => s.classList.toggle('bcos-gallery__slide--active', i === next));
    thumbs.forEach((t) => {
      t.classList.toggle('bcos-gallery__thumb--active', t.dataset.mediaId === slides[next].dataset.mediaId);
    });

    const thumb = thumbs.find((t) => t.dataset.mediaId === slides[next].dataset.mediaId);
    if (thumb && thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    updateCounter();
    if (enableLightbox && lightbox && !options.skipLightbox && !lightbox.hidden) {
      renderLightbox(next);
    }
    if (!options.silent) {
      track('gallery_media_change', { index: next, type: slides[next].dataset.mediaType });
    }
  }

  function updateCounter() {
    if (!counter) return;
    const index = currentIndex();
    if (index >= 0) counter.textContent = `${index + 1} / ${slides.length}`;
  }

  prevBtn?.addEventListener('click', () => {
    const index = currentIndex();
    setActive(index <= 0 ? slides.length - 1 : index - 1);
  });
  nextBtn?.addEventListener('click', () => {
    const index = currentIndex();
    setActive(index >= slides.length - 1 ? 0 : index + 1);
  });
  expandBtn?.addEventListener('click', () => {
    if (enableLightbox) openLightbox(currentIndex());
  });

  /* ---------------------------------------------------------- */
  /* Hover zoom (desktop) + click opens lightbox                 */
  /* ---------------------------------------------------------- */
  main?.addEventListener('click', (event) => {
    const slide = event.target.closest('[data-gallery-slide]');
    if (!slide) return;
    if (enableZoom && window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (enableLightbox && slide.dataset.mediaType === 'image') openLightbox(currentIndex());
  });

  if (enableZoom) {
    main?.addEventListener('mousemove', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const img = event.target.closest('.bcos-gallery__media--image img');
      if (!img) return;
      img.classList.add('bcos-gallery__image--zoomed');
      const rect = img.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });
    main?.addEventListener('mouseleave', (event) => {
      const img = event.target.closest('.bcos-gallery__media--image img');
      if (img) {
        img.classList.remove('bcos-gallery__image--zoomed');
        img.style.transformOrigin = '50% 50%';
      }
    });
  }

  /* ---------------------------------------------------------- */
  /* Lightbox                                                    */
  /* ---------------------------------------------------------- */
  const lightboxStage = lightbox?.querySelector('[data-lightbox-stage]');
  const lightboxCounter = lightbox?.querySelector('[data-lightbox-counter]');
  const lightboxPrev = lightbox?.querySelector('[data-lightbox-prev]');
  const lightboxNext = lightbox?.querySelector('[data-lightbox-next]');
  const lightboxClose = lightbox?.querySelector('[data-lightbox-close]');
  const lightboxImg = lightbox?.querySelector('[data-lightbox-img]');

  function renderLightbox(index) {
    if (!lightbox || !lightboxStage) return;
    const slide = slides[index];
    if (!slide) return;

    lightboxStage.innerHTML = '';
    const type = slide.dataset.mediaType;
    if (type === 'video' || type === 'external_video') {
      const source = slide.querySelector('video, iframe');
      if (source) {
        const clone = source.cloneNode(true);
        clone.classList.add('bcos-lightbox__media');
        if (clone.tagName === 'VIDEO') clone.controls = true;
        lightboxStage.appendChild(clone);
      } else {
        lightboxStage.appendChild(createLightboxImage(slide));
      }
    } else {
      lightboxStage.appendChild(createLightboxImage(slide));
    }
    if (lightboxCounter) lightboxCounter.textContent = `${index + 1} / ${slides.length}`;
    track('gallery_lightbox_media', { index, type });
  }

  function createLightboxImage(slide) {
    const img = new Image();
    img.classList.add('bcos-lightbox__image');
    img.alt = slide.dataset.lightboxAlt || '';
    img.src = slide.dataset.lightboxSrc || '';
    img.loading = 'eager';
    return img;
  }

  function openLightbox(index) {
    if (!lightbox) return;
    if (hasModels && !window.Shopify?.loadedModelViewer && typeof document.documentElement.loadModelViewer === 'function') {
      document.documentElement.loadModelViewer();
    }
    lightbox.hidden = false;
    document.body.classList.add('bcos-lightbox-open');
    document.addEventListener('keydown', onLightboxKeydown);
    renderLightbox(index);
    track('gallery_lightbox_open', { index });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('bcos-lightbox-open');
    document.removeEventListener('keydown', onLightboxKeydown);
    if (lightboxStage) lightboxStage.innerHTML = '';
    track('gallery_lightbox_close');
  }

  function onLightboxKeydown(event) {
    if (event.key === 'Escape') {
      closeLightbox();
      return;
    }
    const index = currentIndex();
    if (event.key === 'ArrowLeft') {
      setActive(index <= 0 ? slides.length - 1 : index - 1);
    } else if (event.key === 'ArrowRight') {
      setActive(index >= slides.length - 1 ? 0 : index + 1);
    }
  }

  lightboxPrev?.addEventListener('click', () => {
    const index = currentIndex();
    setActive(index <= 0 ? slides.length - 1 : index - 1);
  });
  lightboxNext?.addEventListener('click', () => {
    const index = currentIndex();
    setActive(index >= slides.length - 1 ? 0 : index + 1);
  });
  lightboxClose?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  let touchStartX = null;
  if (enableSwipe) {
    lightbox?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    lightbox?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 48) {
        const index = currentIndex();
        if (delta < 0) setActive(index >= slides.length - 1 ? 0 : index + 1);
        else setActive(index <= 0 ? slides.length - 1 : index - 1);
      }
      touchStartX = null;
    }, { passive: true });
  }

  /* Double-tap zoom on lightbox images */
  let lastTap = 0;
  lightboxStage?.addEventListener('touchend', (event) => {
    if (event.target.closest('video, iframe')) return;
    const now = Date.now();
    if (now - lastTap < 300) {
      const img = lightboxStage.querySelector('.bcos-lightbox__image');
      if (img) img.classList.toggle('bcos-lightbox__image--zoomed');
    }
    lastTap = now;
  });

  /* Sync counter when variant change swaps active media (from product.js) */
  const observer = new MutationObserver(() => updateCounter());
  slides.forEach((slide) => {
    observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---------------------------------------------------------- */
  /* Model viewer lazy load                                      */
  /* ---------------------------------------------------------- */
  if (hasModels) {
    const script = document.createElement('script');
    script.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.12.0/model-viewer.js';
    script.async = true;
    document.head.appendChild(script);
    window.Shopify = window.Shopify || {};
    window.Shopify.loadedModelViewer = true;
  }

  updateCounter();
})();
